import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Row, Col, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { clone, cloneDeep, isEmpty } from "lodash";
import APIClient from '../../../helpers/APIClient';
import Loader from '../../../components/Loader';
import { baseUrl } from '../../../constants/environment';
import styled from 'styled-components';
import ProductInfo from './../components/ProductInfo';
import ProductStockFirst from './../components/ProductStockFirst';
import ProductUnit from './../components/ProductUnit';
import ProductAattributes from './../components/ProductAattributes';
import ProductPrice from './../components/ProductPrice';
import ProductStock from './../components/ProductStock';
import ProductExpiration from './../components/ProductExpiration';
import ProductImages from './../components/ProductImages';
import ProductVarriant from './../components/ProductVarriant';

const ProductContentPageAdd = forwardRef((props: any, ref:any) => {
    const {
        data, type, setData, category, brand, origin, onlyView, id, imgs, setImgs, action, handleActionModal,
        branch, stock, setStock, unit, attributes, setAttributes, setUnit, varriant, age, pathologicals
    } = props

    const [loading, setLoading] = useState(false)
    const [validation, setValidation] = useState<any>({})

    const router = useHistory()

    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        const newData = {
            ...data,
            [name]: value
        }
        props?.handleChangeInput(event)
        validationFrom(false, event?.target?.name, {data: newData})
    }

    useImperativeHandle(ref, () => ({

        validationFrom() {
            validationFrom(false)
        }
    
      }));
      
    const validationFrom = (showToastValidation?:boolean, nameValidation?:string, dataCur?:any, dataValidation?:any) => {
        let {
            data, type, setData, category, brand, origin, onlyView, id, imgs, setImgs, action, handleActionModal,
            branch, stock, setStock, unit, attributes, setAttributes, setUnit, varriant
        } = props
        
        if(dataCur?.data) data= dataCur?.data
        if(dataCur?.stock) stock= dataCur?.stock
        if(dataCur?.unit) unit= dataCur?.unit
        if(dataCur?.imgs) imgs= dataCur?.imgs
        if(dataCur?.attributes) attributes= dataCur?.attributes
        let newValidation:any = {}
        let toastValidation = []
        if(props?.user?.store_id?.is_erp_stock && isEmpty(data.erp_sku)){
            toastValidation.push('SKU ERP không được để trống!')
            newValidation.erp_sku = 'SKU ERP không được để trống!'
        }
        if (isEmpty(data.name)) {
            toastValidation.push('Tên sản phẩm không được để trống!')
            newValidation.name = 'Tên sản phẩm không được để trống!'
        }
        if(!data?.product_age_id) {
            toastValidation.push('Độ tuổi không được để trống!')
            newValidation.product_age_id = 'Độ tuổi không được để trống!'
        }
        if (isEmpty(data.type)) {
            toastValidation.push('Kiểu quản lý không được để trống!')
            newValidation.type = 'Kiểu quản lý không được để trống!'
        }
        if (isEmpty(data.product_type)) {
            toastValidation.push('Loại sản phẩm không được để trống!')
            newValidation.product_type = 'Loại sản phẩm không được để trống!'
        }
        if (!data.category_id) {
            toastValidation.push('Danh mục không được để trống!')
            newValidation.category_id = 'Danh mục không được để trống!'
        }
        if (isEmpty(data.used_unit)) {
            toastValidation.push('Đơn vị sử dụng không được để trống!')
            newValidation.used_unit = 'Đơn vị sử dụng không được để trống!'
        }
        if (isEmpty(data.minimum_unit)) {
            toastValidation.push('Đơn vị không được để trống!')
            newValidation.minimum_unit = 'Đơn vị không được để trống!'
        }
        if (!(data.price)) {
            toastValidation.push('Giá bán lẻ không được để trống!')
            newValidation.price = 'Giá bán lẻ không được để trống!'
        }
        //nhập tồn đầu
        if (id === 'add' && data?.stock_first_status) {
            const checkStockFirst = stock?.reduce((prev:any, item:any, index:number)=>{
                if(
                    (item?.branch_id && (!item?.quantity || !item?.price_cost))
                    || (item?.quantity && (!item?.branch_id || !item?.price_cost))
                    || (item?.price_cost && (!item?.branch_id || !item?.quantity))
                ){
                    if(!newValidation.stock) newValidation.stock = {}
                    if(!newValidation.stock[index]) newValidation.stock[index] = {}
                    if(item?.branch_id && !item?.quantity) newValidation.stock[index].quantity = 'Tồn đầu không được để trống!'
                    if(item?.branch_id && (!item?.price_cost)) newValidation.stock[index].price_cost = 'Giá vốn không được để trống!'
                    if(item?.quantity && (!item?.branch_id)) newValidation.stock[index].branch_id = 'Chi nhánh không được để trống!'
                    if(item?.quantity && (!item?.price_cost)) newValidation.stock[index].price_cost = 'Giá vốn không được để trống!'
                    if(item?.price_cost && (!item?.branch_id)) newValidation.stock[index].branch_id = 'Chi nhánh không được để trống!'
                    if(item?.price_cost && (!item?.quantity)) newValidation.stock[index].quantity = 'Tồn đầu không được để trống!'
                    prev = false
                }
                return prev
            }, true)
            if (!checkStockFirst) {
                toastValidation.push('Nhập tồn đầu không được để trống!')
                newValidation.stock_first_status = 'Nhập tồn đầu không được để trống!'
            }
        }
        //Quy đổi đơn vị
        if (data?.unit_status) {
            const checkUnit = unit?.reduce((prev:any, item:any, index:number)=>{
                if(
                    (item?.name && !item?.quantity_conversion)
                    || (!item?.name && item?.quantity_conversion)
                ){
                    if(!newValidation.unit) newValidation.unit = {}
                    if(!newValidation.unit[index]) newValidation.unit[index] = {}
                    if(item?.name && !item?.quantity_conversion) newValidation.unit[index].quantity_conversion = 'Giá trị không được để trống!'
                    if(!item?.name && item?.quantity_conversion) newValidation.unit[index].name = 'Tên đơn vị không được để trống!'
                    prev = false
                }
                return prev
            }, true)
            if (!checkUnit) {
                toastValidation.push('Quy đổi đơn vị không được để trống!')
            }
            var valueNameArr = data?.product_units?.map(function(item:any){ return item.name });
            var isNameDuplicate = valueNameArr?.some(function(item:any, idx:any){ 
                return valueNameArr?.indexOf(item) != idx 
            });
            if(isNameDuplicate) {
                toastValidation.push('Tên của đơn vị quy đổi không được trùng nhau!')
                newValidation.unit_name = 'Tên của đơn vị quy đổi không được trùng nhau!'
            }
            var valueArr = data?.product_units?.map(function(item:any){ return item.quantity_conversion });
            var isDuplicate = valueArr?.some(function(item:any, idx:any){ 
                return valueArr?.indexOf(item) != idx 
            });
            if(isDuplicate) {
                toastValidation.push('Giá trị của đơn vị quy đổi không được trùng nhau')
                newValidation.unit_quantity_conversion = 'Giá trị của đơn vị quy đổi không được trùng nhau'
            }
        }
        //Thuộc tính
        if (data?.attributes_status) {
            const checkAttributes = attributes?.reduce((prev:any, item:any, index:number)=>{
                if(
                    (item?.name && item?.properties?.length === 0)
                    || (!item?.name && item?.properties?.length !== 0)
                ){
                    if(!newValidation.attributes) newValidation.attributes = {}
                    if(!newValidation.attributes[index]) newValidation.attributes[index] = {}
                    if(item?.name && item?.properties?.length === 0) newValidation.attributes[index].properties = 'Giá trị không được để trống!'
                    if(!item?.name && item?.properties?.length !== 0) newValidation.attributes[index].name = 'Tên thuộc tính không được để trống!'
                    prev = false
                }
                return prev
            }, true)
            if (!checkAttributes) {
                toastValidation.push('Thuộc tính không được để trống!')
            }
        }
        // Cấu hình định mức tồn
        if (data?.stock_status) {
            if (!(data.stock_min)) {
                toastValidation.push('Tồn tối thiểu không được để trống!')
                newValidation.stock_min = 'Tồn tối thiểu không được để trống!'
            }
            if (!(data.stock_max)) {
                toastValidation.push('Tồn tối đa không được để trống!')
                newValidation.stock_max = 'Tồn tối đa không được để trống!'
            }
        }
        // Cảnh báo hết hạn
        if (data?.expiration_status) {
            if (!(data.expiration_day_number)) {
                toastValidation.push('Ngày đến hạn không được để trống!')
                newValidation.expiration_day_number = 'Ngày đến hạn không được để trống!'
            }
            if (!(data.warning_day_number)) {
                toastValidation.push('Ngày cảnh báo không được để trống!')
                newValidation.warning_day_number = 'Ngày cảnh báo không được để trống!'
            }
        }
        if (imgs?.length === 0) {
            toastValidation.push('Hình ảnh không được để trống!')
            newValidation.imgs = 'Hình ảnh không được để trống!'
        }
        //Biến thể
        if (varriant?.length > 0) {
            const checkVarriant = varriant?.reduce((prev:any, item:any, index:number)=>{
                if(
                    item?.price?.length === 0
                ){
                    if(!newValidation.varriant) newValidation.varriant = {}
                    if(!newValidation.varriant[index]) newValidation.varriant[index] = {}
                    if(item?.price?.length === 0) newValidation.varriant[index].price = 'Giá trị không được để trống!'
                    prev = false
                }
                const checkVarriantwarehouse = item?.warehouse?.reduce((prevWarehouse:any, itemWarehouse:any, indexWarehouse:number)=>{
                    if(
                        (itemWarehouse?.quantity && !itemWarehouse?.price_cost)
                        || (itemWarehouse?.price_cost && !itemWarehouse?.quantity)
                    ){
                        if(!newValidation.varriant) newValidation.varriant = {}
                        if(!newValidation.varriant[index]) newValidation.varriant[index] = {}
                        if(!newValidation.varriant[index].branch) newValidation.varriant[index].branch = {}
                        if(!newValidation.varriant[index].branch[itemWarehouse?.branch_id]) newValidation.varriant[index].branch[itemWarehouse?.branch_id] = {}
                        newValidation.varriant[index].branch[itemWarehouse?.branch_id].price_cost
                        = newValidation.varriant[index].branch[itemWarehouse?.branch_id].quantity = ''
                        if(itemWarehouse?.quantity && !itemWarehouse?.price_cost) newValidation.varriant[index].branch[itemWarehouse?.branch_id].price_cost = 'Giá vốn không được để trống!'
                        if(itemWarehouse?.price_cost && !itemWarehouse?.quantity) newValidation.varriant[index].branch[itemWarehouse?.branch_id].quantity = 'Tồn đầu không được để trống!'
                        prevWarehouse = false
                    }
                    return prevWarehouse
                }, true)
                if(!checkVarriantwarehouse) prev = false
                return prev
            }, true)
            if (!checkVarriant) {
                toastValidation.push('Nhập đầy đủ thông tin biến thể!')
            }
        }
        if(nameValidation){
            newValidation = {
                ...cloneDeep(validation),
                [nameValidation]: newValidation[nameValidation]
            }
        }
        if(dataValidation){
            newValidation = dataValidation
        }
        console.log("newValidation", newValidation)
        setValidation(newValidation)
        if(toastValidation?.length > 0){
            showToastValidation && toast.warning(toastValidation.join(', '));
            return false
        }
        return true
    }

    const handleSubmit = async () => {
        data.product_variants = varriant?.reduce((prev:any, item:any)=>{
            prev = [...prev, {
                barcode: item?.barcode,
                name: item?.name,
                price: Number(item?.price),
                price_import: Number(item?.price_import),
                price_wholesale: Number(item?.price_wholesale),
                sku: item?.sku,
                variant_name: item?.variant_name,
                vat: Number(item?.vat),
                weight: Number(item?.weight),
                width: Number(data?.width),
                longs: Number(data?.longs),
                height: Number(data?.height),
                unit_value: Number(item?.unit_value || 1),
                unit_name: item?.unit_name || undefined,
                parent_sku: item?.parent || item?.isRoot && 'isUnitByRoot',
                stock_first: item?.warehouse?.reduce((prevStock:any, itemStock:any)=>{
                    prevStock =[...prevStock,{
                        ...itemStock,
                        quantity: Number(itemStock?.quantity),
                        price_cost: Number(itemStock?.price_cost)
                    }]
                    return prevStock
                },[]),
            }]
            const unitVarriant:any = item?.units?.reduce((prevUnit:any, itemUnit:any)=>{
                prevUnit = [...prevUnit, {
                    barcode: itemUnit?.barcode,
                    name: itemUnit?.name,
                    price: Number(itemUnit?.price),
                    price_import: Number(itemUnit?.price_import),
                    price_wholesale: Number(itemUnit?.price_wholesale),
                    sku: itemUnit?.sku,
                    variant_name: itemUnit?.variant_name,
                    vat: Number(itemUnit?.vat),
                    weight: Number(itemUnit?.weight),
                    width: Number(data?.width),
                    longs: Number(data?.longs),
                    height: Number(data?.height),
                    unit_value: Number(itemUnit?.unit_value || 1),
                    unit_name: itemUnit?.unit_name || undefined,
                    parent_sku: itemUnit?.parent,
                }]
                return prevUnit
            },[]) || []
            prev = [...prev, ...unitVarriant]
            return prev
        },[])
        data.product_units = unit?.reduce((prev:any, item:any)=>{
            if(item?.name && item?.quantity_conversion){
                prev = [...prev, {
                    ...item,
                    quantity_conversion: Number(item?.quantity_conversion)
                }]
            }
            return prev
        },[])
        data.product_attributes = attributes?.reduce((prev:any, item:any)=>{
            if(item?.name && item?.properties?.length !== 0){
                prev = [...prev, item]
            }
            return prev
        },[])
        data.product_stock_firsts = stock?.reduce((prev:any, item:any)=>{
            if(item?.branch_id && item?.quantity && item?.price_cost){
                prev = [...prev, {
                    ...item,
                    quantity: Number(item?.quantity),
                    price_cost: Number(item?.price_cost),
                }]
            }
            return prev
        },[])
        data.product_images = imgs
        if (!validationFrom(true)) return;
        setLoading(true)
        const url = `${baseUrl}/product`;
        const params = {
            ...data,
            price: Number(data?.price),
            price_import: Number(data?.price_import),
            price_wholesale: Number(data?.price_wholesale),
            vat: Number(data?.vat),
            weight: Number(data?.weight),
            width: Number(data?.width),
            longs: Number(data?.longs),
            height: Number(data?.height),
            stock_min: Number(data?.stock_min),
            stock_max: Number(data?.stock_max),
            expiration_day_number: Number(data?.expiration_day_number),
            warning_day_number: Number(data?.warning_day_number),
            vat_enable: data?.vat_enable ? 1 : 0,
            usage: data?.usage ? data?.usage?.map((u:any) => u.value).join(',') : '',
            ingredient: data?.ingredient ? data?.ingredient?.map((u:any) => u.text).join(',') : '',
            product_pathological_ids: data?.product_pathological_ids?.map((item: any) => item?.id)
        }
        delete params.product_stock_transfer
        delete params.product_stock_hold
        delete params.product_stock
        let response: any = await APIClient.POST(url, params);
        
        setLoading(false) 
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo mới sản phẩm thành công')
            router?.push('/product/list')
        }
    }
    

    return (
        <PageContent className={onlyView ? 'only-view' : ''}>
            <Row>
                <Col md={6}>
                    <ProductInfo {...props} handleChangeInput={handleChangeInput} validation={validation} setLoading={setLoading} loading={loading}/>
                    {id === 'add' && !props?.user?.store_id?.is_erp_stock &&
                        <ProductStockFirst {...props} validation={validation} onValidation={(dataValidation:any)=>{
                            validationFrom(false, '', null, dataValidation)
                        }} />
                    }
                    {props?.user?.store_id?.is_erp_stock ? <></>:
                    <>
                    <ProductUnit {...props} validation={validation} onValidation={(dataValidation:any)=>{
                        validationFrom(false, '', null, dataValidation)
                    }} />
                    <ProductAattributes {...props} validation={validation} onValidation={(dataValidation:any)=>{
                        validationFrom(false, '', null, dataValidation)
                    }}/>
                    </>}
                    
                </Col>
                <Col md={6}>
                    <ProductPrice {...props} handleChangeInput={handleChangeInput} validation={validation}  />
                    <ProductStock {...props} handleChangeInput={handleChangeInput} validation={validation} />
                    {data?.type === 'batch' && <ProductExpiration {...props} handleChangeInput={handleChangeInput} validation={validation} />}
                    <ProductImages {...props} handleChangeInput={handleChangeInput} validation={validation} />
                </Col>
                <Col md={12}>
                    <ProductVarriant {...props} id={id} handleChangeInput={handleChangeInput} validation={validation} onValidation={(dataValidation:any)=>{
                        validationFrom(false, '', null, dataValidation)
                    }}/>
                </Col>
            </Row>
            <div className="bottom-action">
                <Button color="success" className='success-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                <Button color="success" className='ml-2' onClick={handleSubmit}>Lưu lại</Button>
            </div>
            {loading && <Loader />}
        </PageContent>
    )
})

export const PageContent = styled.div`
    padding-bottom: 60px;
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

export default ProductContentPageAdd